import { isSindaraOrigin } from '@resources/lms-management/types'
import { PROGRAM_LOCAL_STATE } from '../program-lokal/types'
import { TLMSClass } from './types'

export const canAssignSindaraParticipants = (
  programLocalStatus?: PROGRAM_LOCAL_STATE,
) =>
  programLocalStatus === PROGRAM_LOCAL_STATE.DRAFT ||
  programLocalStatus === PROGRAM_LOCAL_STATE.PUBLISHED

export const shouldHideClassParticipantMigration = (classDetail?: TLMSClass) =>
  !classDetail || isSindaraOrigin(classDetail.origin)
